import { useState } from "react";
import { Formik, Form } from "formik";
import { TextField } from "./TextField";
import * as Yup from "yup";
import emailjs from "@emailjs/browser";
import ConfirmationModal from "./ConfirmationModal";
import { Loader, Button } from "semantic-ui-react";

export default function ContactForm() {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const schema = Yup.object().shape({
    Namn: Yup.string().max(15).required("Obligatoriskt"),
    Epost: Yup.string().email("Ogiltig mejladress").required("Obligatoriskt"),
    TelefonNummer: Yup.number()
      .typeError("Ange bara siffror")
      .required("Obligatoriskt"),
    RegistreringNummer: Yup.string().required("Obligatoriskt"),
    OnskatPris: Yup.number().typeError("Ange bara siffror"),
    EventuellaDefekter: Yup.string(),
  });

  function sendEmail(values) {
    setLoading(true);
    emailjs
      .send(
        process.env.REACT_APP_serviceId,
        process.env.REACT_APP_templateId,
        values,
        process.env.REACT_APP_userId,
      )
      .then(
        (res) => {
          setLoading(false);
          setOpen(true);
        },
        (error) => {
          alert("Något Fel, Försök Igen Senare");
          setLoading(false)
        }
      );
  }

  return (
    <Formik
      initialValues={{
        Namn: "",
        Epost: "",
        TelefonNummer: "",
        RegistreringNummer: "",
        OnskatPris: "",
        EventuellaDefekter: "",
      }}
      isSubmitting={() => {
        <Loader />;
      }}
      validationSchema={schema}
      onSubmit={(values, { isSubmitting, setSubmitting, resetForm }) => {
        sendEmail(values);
        setSubmitting(false);
        resetForm();
      }}
    >
      {(formik) => (
        <div className="l-form">
          <Form className="form" onSubmit={formik.handleSubmit}>
            <TextField label="Namn" name="Namn" type="text" />
            <TextField label="E-post" name="Epost" type="text" />
            <TextField label="Telefonnummer" name="TelefonNummer" type="text" />
            <TextField
              label="Registreringsnummer"
              name="RegistreringNummer"
              type="text"
            />
            <TextField label="Önskat Pris" name="OnskatPris" type="text" />
            <TextField
              label="Eventuella defekter"
              name="EventuellaDefekter"
              type="text"
            />

            <Button
              size={"large"}
              style={{ align: "center" }}
              loading={loading}
              type="submit"
              className="ui orange inverted button"
            >
              SKICKA
            </Button>
            <ConfirmationModal  setOpen={setOpen} open={open} />
          </Form>
        </div>
      )}
    </Formik>
  );
}
